import { Theme } from "@/constants/enums";

// Define the type for the configuration function
type ConfigFunction = (
    theme: string,
    dimension: { width: number },
) => {
    columns: Record<string, string>[];
    columnStyles: { [key: string]: React.CSSProperties };
    title: string;
};

// Define the custom style map
export const customPropsMap: { [key: string]: ConfigFunction } = {
    sport_cricket_series_key_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "team", header: "TEAM" },
            { accessor: "matches", header: "MAT" },
            { accessor: "average", header: "AVG" },
        ],
        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },
            team: {
                maxWidth: "60px",
                minWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "50px",
                minWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },
            matches: {
                maxWidth: "50px",
                minWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            average: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },
        title: "Most Runs",
    }),

    sport_cricket_series_highest_individual_score_batsmen: (
        theme,
        dimension,
    ) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "highestIndividual", header: "RUNS" },
            { accessor: "team", header: "TEAM" },
            { accessor: "strike", header: "SR" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },
            highestIndividual: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },
            team: {
                maxWidth: "60px",
                minWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            strike: {
                maxWidth: "60px",
                minWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },
        title: "Highest Individual Scores",
    }),

    sport_cricket_series_best_batting_averages_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "average", header: "AVG" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },
            average: {
                minWidth: "55px",
                maxWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },
            team: {
                minWidth: "60px",
                maxWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "50px",
                minWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            matches: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Best Batting Averages",
    }),
    sport_cricket_series_best_strike_rate_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "strike", header: "SR" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "average", header: "AVG" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },

            strike: {
                minWidth: "55px",

                maxWidth: "55px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            runs: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            average: {
                maxWidth: "55px",

                minWidth: "55px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Best Strike Rate",
    }),

    sport_cricket_series_most_hundreds_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "hundreds", header: "100s" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "matches", header: "MAT" },
        ],
        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#4B5563"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },
            hundreds: {
                minWidth: "50px",
                maxWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },
            team: {
                minWidth: "60px",
                maxWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            matches: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },
        title: "Most 100s",
    }),

    sport_cricket_series_most_fifties_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "fifties", header: "50s" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },

            fifties: {
                minWidth: "50px",
                maxWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",
                maxWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most 50s",
    }),

    sport_cricket_series_most_fours_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "fours", header: "4s" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },

            fours: {
                minWidth: "50px",
                maxWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",
                maxWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most 4s",
    }),

    sport_cricket_series_most_sixes_batsmen: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },
            { accessor: "sixes", header: "6s" },
            { accessor: "team", header: "TEAM" },
            { accessor: "runs", header: "RUNS" },
            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",
                textAlign: "left",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "500" : "600",
                maxWidth: dimension?.width > 320 ? "unset" : "unset",
            },

            sixes: {
                minWidth: "50px",
                maxWidth: "50px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",
                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",
                maxWidth: "60px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
            runs: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "55px",
                minWidth: "55px",
                textAlign: "center",
                justifyContent: "center",
                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",
                fontWeight: dimension?.width > 640 ? "600" : "600",
                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most 6s",
    }),

    sport_cricket_series_key_bowlers: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "wickets", header: "WKTS" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "average", header: "AVG" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            average: {
                maxWidth: "55px",

                minWidth: "55px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most Wickets",
    }),

    sport_cricket_series_most_maiden_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "maidens", header: "MAID" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            maidens: {
                minWidth: "62px",

                maxWidth: "62px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "60px",

                minWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most Maidens",
    }),

    sport_cricket_series_best_economy_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "economy", header: "ECON" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            economy: {
                maxWidth: "60px",

                minWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                justifyContent: "center",

                textAlign: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Best Economy",
    }),

    sport_cricket_series_best_strike_rate_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "strike", header: "SR" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            strike: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Best Strike Rate",
    }),

    sport_cricket_series_most_four_wickets_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "fiveWickets", header: "4 WKTS" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            fiveWickets: {
                minWidth: "62px",

                maxWidth: "62px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most 4-Wickets Haul",
    }),

    sport_cricket_series_most_five_wickets_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "fiveWickets", header: "5 WKTS" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            fiveWickets: {
                minWidth: "62px",

                maxWidth: "62px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most 5-Wickets Haul",
    }),

    sport_cricket_series_best_bowling_figures_bowler: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "BBI", header: "BBI" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },

            { accessor: "wickets", header: "WKTS" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",

                maxWidth: dimension?.width > 320 ? "unset" : "150px",
            },

            BBI: {
                minWidth: "62px",

                maxWidth: "62px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            wickets: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Best Bowling Figures In An Innings",
    }),

    sport_cricket_series_most_dismissals_keeper: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "dismissals", header: "DISM" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            dismissals: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",
            },
        },

        title: "Most Dismissals",
    }),

    sport_cricket_series_most_catches_fielder: (theme, dimension) => ({
        columns: [
            { accessor: "batter", header: "PLAYER" },

            { accessor: "catches", header: "CT" },

            { accessor: "team", header: "TEAM" },

            { accessor: "matches", header: "MAT" },
        ],

        columnStyles: {
            batter: {
                minWidth: "112px",

                textAlign: "left",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "500" : "600",
            },

            team: {
                minWidth: "60px",

                maxWidth: "60px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            matches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#374151",

                fontWeight: dimension?.width > 640 ? "600" : "600",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },

            catches: {
                maxWidth: "50px",

                minWidth: "50px",

                textAlign: "center",

                justifyContent: "center",

                color:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "#374151"
                            : "#ffffff"
                        : "#111827",

                fontWeight: dimension?.width > 640 ? "900" : "900",

                opacity:
                    theme === Theme.DARK
                        ? dimension?.width > 640
                            ? "1"
                            : "0.8"
                        : "0.9",
            },
        },

        title: "Most Catches",
    }),
};
